module.exports = __webpack_public_path__ + "img/male-condom.17d78a3a.png";